export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11493.4d7c703c.jpg";